import React from 'react';
import {
    Item,
    Button,
    Icon,
    Image,
    Label
} from 'semantic-ui-react';

const clinicTypeCode = {
    0 : "Others",
    1 : "General Practitioners",
    2 : "Specialists",
    3 : "Dental",
    4 : "Xray Centre",
    5 : "Physiotherapy",
    6 : "Traditional Chinese Medicine",
    7 : "Polyclinic",
    8 : "Hospital",
    9 : "Lab",
}

const zoneTypeCode = {
    1 : "North",
    2 : "South",
    3 : "East",
    4 : "West",
    5 : "North East",
    6 : "North West",
    7 : "South East",
    8 : "South West",
}

const ClinicListItem = (props) => {
    const {
        a, // address
        ar, // Area (e.g. Tampines)
        t, // clinic type code
        z, // zone type code
        c, // ?
        d, // doctor name
        h1, // operating hours 1
        h2, // operating hours 2
        h3, // operating hours 3
        h4, // operating hours 4
        la, // lat
        lo, // long
        n, // clinic name
        ts // type display string
    } = props.data;
    const BASE_GOOGLEMAP_URL = 'https://www.google.com/maps/search/?api=1&query=';
    return (
        <Item key={c}>
            <Item.Image src={`https://app.mhc.asia/v2/api/clinics/${c}/image`} />
            <Item.Content>
                <Item.Header>
                    {n} 
                </Item.Header>
                <Item.Meta>
                    <Label>
                        {ar}
                    </Label>
                    <span className='cinema'>{a}</span>
                </Item.Meta>
                <Item.Description>
                    <p>
                        {h1}
                        <br />
                        {h2}
                        <br />
                        {h3}
                        <br />
                        {h4}
                    </p>
                    <Label>{ts}</Label>
                    {/*<Label>{zoneTypeCode[z] || 'Unknown Zone'}</Label>*/}
                </Item.Description>
                <Item.Extra>
                    <a href={`${BASE_GOOGLEMAP_URL}${la},${lo}`} target="_blank">
                        <Button primary floated='right'>
                            View On Map
                            <Icon name='right chevron' />
                        </Button>
                    </a>
                </Item.Extra>
            </Item.Content>
        </Item>
    );
}

export default ClinicListItem;